// Ce que chaque app fournit aux composants partagés.
//
// Règle du paquet : aucune dépendance plateforme. L'extension a son i18n, son
// analytics et l'URL du Chrome Web Store ; la console a les siens (ou rien).
// Plutôt que d'importer l'un ou l'autre, les composants les REÇOIVENT.

/** Traduction d'une clé, avec substitution optionnelle. L'extension branche
 *  son i18n multilingue ; la console un simple dictionnaire français. */
export type TranslateFn = (key: string, vars?: Record<string, string | number>) => string

/** Mesure d'usage. Optionnelle : la console n'en a pas et ne doit pas en avoir
 *  besoin pour fonctionner. */
export type CaptureFn = (event: string, props?: Record<string, unknown>) => void

export const noopCapture: CaptureFn = () => {}

/** Construit une fonction de traduction à partir d'un dictionnaire plat.
 *  Une clé absente est renvoyée telle quelle : un libellé moche vaut mieux
 *  qu'un composant qui plante. */
export function dictTranslate(dict: Record<string, string>): TranslateFn {
  return (key, vars) => {
    let out = dict[key] ?? key
    if (vars) for (const [k, v] of Object.entries(vars)) out = out.replaceAll(`{${k}}`, String(v))
    return out
  }
}
